module.exports = __webpack_public_path__ + "img/vault.1cf32da4.svg";